import {
  Download as DownloadIcon,
  DriveFileRenameOutline as RenameIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";

interface PreviewActionsProps {
  fileName: string;
  onDownload: () => void;
  onToggleFullscreen?: () => void;
  isFullscreen?: boolean;
  onClose: () => void;
  disableDownload?: boolean;
  /** The renderer offers its own download menu in the header slot. */
  hideDownload?: boolean;
  /** Offered when the person may rename the file. */
  onRename?: () => void;
}

const PreviewActions: React.FC<PreviewActionsProps> = ({
  fileName,
  onDownload,
  onToggleFullscreen,
  isFullscreen,
  onClose,
  disableDownload,
  hideDownload,
  onRename,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {onRename && (
        <Tooltip title="Rename">
          <IconButton
            onClick={onRename}
            size="small"
            aria-label={`Rename ${fileName}`}
          >
            <RenameIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {!hideDownload && (
        <Tooltip title="Download">
          <span>
            <IconButton
              onClick={onDownload}
              size="small"
              disabled={disableDownload}
              aria-label={`Download ${fileName}`}
            >
              <DownloadIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {onToggleFullscreen && (
        <Tooltip title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}>
          <IconButton
            onClick={onToggleFullscreen}
            size="small"
            aria-label="Toggle fullscreen"
          >
            {isFullscreen ? (
              <FullscreenExitIcon fontSize="small" />
            ) : (
              <FullscreenIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Close">
        <IconButton onClick={onClose} size="small" aria-label="Close preview">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PreviewActions;
